import { codeSplit, Controller, FetchOptions, Result } from 'bernie-core';
import { PageData } from 'bernie-http';
import '../client/temp-common-imports';

import { QuicklinkStore } from 'stores';

export class QuicklinksController implements Controller {
  public pageId = 'Quicklinks';
  public path = '/:localeName/quicklinks';
  public routeName = 'quicklinks';
  public bundles = [];

  public component = codeSplit(
    () => import(/* webpackChunkName: "uis-prime-example-page" */ '../views/quicklinks-page'),
  );
  public exact = true;

  // tslint:disable-next-line:prefer-function-over-method
  public fetch(options: FetchOptions): Promise<any> {
    const query = options.query;
    const stores = options.stores;
    const quicklinkStore = stores.get<QuicklinkStore>('quicklinks');

    if (quicklinkStore) {
      return quicklinkStore.fetch(query.programName);
    }

    return Promise.resolve(Result.ok());
  }

  // tslint:disable-next-line:prefer-function-over-method
  public fetchPageData(): Promise<PageData> {
    return Promise.resolve({ title: 'Affiliate Hub Quicklinks' }) as Promise<PageData>;
  }
}
